import axios from 'axios'

import { toast } from 'react-toastify'

const URL = process.env.REACT_APP_API_URL

export const instance = axios.create({ baseURL: URL })

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    toast.error(error.response.data.message)
    return error
  }
)

//TODO SERVER Errors handling

export const headersConfig = (authData: string) => {
  return {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${authData}`
    }
  }
}

export const wpAPI = {
  async fetchLessons() {
    const resp = await instance.get(`/wp/v2/courses`)
    return resp.data
  },
  async creatNewLesson({ authData, post }: any) {
    const config = headersConfig(authData)
    const response = await instance.post(`/wp/v2/lessons`, post, config)
    return response
  },
  async fetchQuestions() {
    const resp = await instance.get(`/wp/v2/questions`)
    return resp.data
  },
  async creatNewQuestion({ authData, post }: any) {
    const config = headersConfig(authData)

    const response = await instance.post(`/wp/v2/questions`, post, config)
    return response
  },
  async jwtLogin(userdata: any) {
    try {
      const response = await instance.post('/jwt-auth/v1/token', userdata)
      return response.data
    } catch (e) {
      console.error(e)
      throw e // Re-throwing the error to propagate it further if necessary
    }
  },
  async verifyToken(token: string) {
    try {
      const response = await instance.post(
        '/users/v1/verify-token',
        {},
        {
          headers: {
            Authorization: `${token}`
          }
        }
      )
      if (!response.data) {
        toast.error('בעיות חיבור, אנא נסה שוב מאוחר יותר!')
        return null
      }
      return response.data
    } catch (e) {
      return null
      // Re-throwing the error to propagate it further if necessary
    }
  }
}
